import React from 'react';
import { renderIntoContainer } from 'react/root/containerRoot';

import LazyLoader from 'imports/LazyLoader.js';

// Mounts the /mod/chats ("Live chat") React page onto its shell container.
$(function() {
	const mount = $('#mod-chats');
	if(!mount.length) {
		return;
	}

	LazyLoader.modChats()
		.then(({ default: ModChats }) => {
			renderIntoContainer(<ModChats />, mount[0]);
		});
});
